var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LeadersWrap',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"offers":_vm.offers,"current-round":_vm.currentRound,"winners":_vm.winners},on:{"update":_vm.loadCurrent}})}
var staticRenderFns = []

export { render, staticRenderFns }